export default {
    payments() {
        return axios.get('/api/ecommerce/payments');
    },
};
